module.exports = __webpack_public_path__ + "649c3eb3d7a85d3753263809f97dc823.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/etsy_2021_chart.png
// module id = 1670
// module chunks = 0